var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button",staticStyle:{"width":"60px"},on:{"click":_vm.clickBtn}},[_vm._v("복사하기")])
}
var staticRenderFns = []

export { render, staticRenderFns }